import { useAppDispatch, useAppState } from '@/store';
import { useEffect, useMemo } from 'react';
import { getAppraisePrice, selectAppraisePrices, selectPricesIsLoading } from '../feature';

export const useGetAppraiserPrice = () => {
  const prices = useAppState(selectAppraisePrices);
  const isLoading = useAppState(selectPricesIsLoading);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getAppraisePrice());
  }, []);

  return useMemo(() => ({ prices, isLoading }), [prices, isLoading]);
};
